import React, { useCallback, useState } from 'react';

import { ArrowRight } from '@travel/icons/ui';
import { IconText } from '@travel/ui';
import { cx } from '@travel/utils';

import styles from './seeMoreLink.module.scss';

type Props = {
  className?: string;
  /** Title string of component */
  title: React.ReactNode;
  /** Callback to be called when the link is clicked */
  onClick?: () => void;
};

function SeeMoreLink(props: Props) {
  const { title, onClick, className, ...rest } = props;
  const [isHovered, setIsHovered] = useState(false);

  const onMouseOver = useCallback(() => setIsHovered(true), []);
  const onMouseOut = useCallback(() => setIsHovered(false), []);

  return (
    <button
      className={styles.button}
      onFocus={onMouseOver}
      onBlur={onMouseOut}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={onClick}
    >
      <IconText
        data-testid="seeMoreLink-button"
        className={cx(className, styles.seeMoreLink)}
        text={title}
        icon={<ArrowRight size={16} color={isHovered ? 'lincolnGreen' : 'cilantro'} />}
        spaceBetween={2}
        iconPosition="right"
        {...rest}
      />
    </button>
  );
}

export default SeeMoreLink;
